import React from 'react';
import { Trans } from '@lingui/react';
import { useFieldArray } from 'react-final-form-arrays';
import { useDropzone } from 'react-dropzone';
import { Sitemap } from '@qover/typography';
import CloseBorderIcon from '@qover/icons/CloseBorderIcon';
import { Error, hasError, PrimaryGhostButton } from '@qover/molecules';
import { arrayMinLength } from '@qover/utils/src/validation';
import { PICTURE_PARTIAL_CONTRACT_COUNT } from '../../utils/bikeConstants';
import { DropzoneBikeIcon } from './DropzoneBikeIcon';
import {
  Caption,
  DropText,
  PictureCount,
  Thumb,
  CloseButton,
  Img,
  DropzoneContainer,
  DropzoneArea,
  MobileDropzoneArea,
  ThumbContainer,
} from './bikeMissingData.styles';

export function BikePicturesDropzone() {
  const { fields: filesFields, meta } = useFieldArray('pictures', {
    validate: arrayMinLength(5, <Trans id="general.minFiles" />),
  });

  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*',
    disabled: filesFields.value?.length === 5,
    maxSize: 25000000,
    onDrop: acceptedFiles => {
      const maxFileCount =
        PICTURE_PARTIAL_CONTRACT_COUNT - (filesFields?.length ?? 0);
      const tmpFiles = acceptedFiles.slice(0, maxFileCount);
      if (maxFileCount > 0) {
        tmpFiles.forEach(file =>
          filesFields.push(
            Object.assign(file, {
              preview: URL.createObjectURL(file),
            }),
          ),
        );
      }
    },
  });

  // useEffect(
  //   () => () => {
  //     // Make sure to revoke the data uris to avoid memory leaks

  //     filesFields.value?.forEach((file: any) =>
  //       URL.revokeObjectURL(file.preview),
  //     );
  //   },
  //   [filesFields.value],
  // );

  function handleRemove(idx: number) {
    const removedFile = filesFields.remove(idx);
    if (removedFile.preview) {
      URL.revokeObjectURL(removedFile.preview);
    }
  }

  return (
    <>
      <DropzoneContainer>
        <Caption>
          <Trans id="bike.missingData.dropArea" />
        </Caption>
        <DropzoneArea {...getRootProps({ className: 'dropzone' })}>
          <input {...getInputProps()} name="pictures" />
          <DropzoneBikeIcon />

          <DropText id="bike.missingData.dragAndDrop" />

          <Sitemap>
            <Trans id="bike.missingData.fileFormats" />
          </Sitemap>
        </DropzoneArea>

        <PictureCount>
          <Trans
            id="bike.missingData.pictureCount"
            defaults="{pictureCount} photo(s) sur 5"
            values={{ pictureCount: filesFields.value?.length ?? 0 }}
          />
        </PictureCount>
        {!!filesFields.value?.length && (
          <div>
            <ThumbContainer onClick={e => e.stopPropagation()}>
              {filesFields.value?.map((file, idx: number) => (
                <Thumb key={file.name}>
                  <Img src={file.preview} />
                  <CloseButton
                    className="close"
                    onClick={() => handleRemove(idx)}
                  >
                    <CloseBorderIcon />
                  </CloseButton>
                </Thumb>
              ))}
            </ThumbContainer>
          </div>
        )}
        <MobileDropzoneArea {...getRootProps({ className: 'dropzone' })}>
          <input {...getInputProps()} name="pictures" />
          <PrimaryGhostButton>
            <Trans id="bike.missingData.uploadPictures" />
          </PrimaryGhostButton>
        </MobileDropzoneArea>
      </DropzoneContainer>
      {hasError(meta) && (
        <Error
          data-test={meta.error && meta.error.code}
          error={meta.error ? meta.error : meta.submitError}
        />
      )}
    </>
  );
}
